import type { TranslatorService } from "@app/services/translator";

const departure_time_range = {
  nighttime: "nighttime",
  early: "early",
  midday: "midday",
  late: "late"
} as const;

type DepartureTimeDataGenerator = (
  translator: TranslatorService,
  doc_count: number
) => {
  label: string;
  countLabel: string;
};

export const departure_time_data = {
  [departure_time_range.nighttime]: (translator, doc_count) => ({
    label: translator.t("!results.filters.departure.time.night.details"),
    countLabel: translator.t("!results.filters.departure.time.night.count", {
      count: doc_count
    })
  }),
  [departure_time_range.early]: (translator, doc_count) => ({
    label: translator.t("!results.filters.departure.time.early.details"),
    countLabel: translator.t("!results.filters.departure.time.early.count", {
      count: doc_count
    })
  }),
  [departure_time_range.midday]: (translator, doc_count) => ({
    label: translator.t("!results.filters.departure.time.midday.details"),
    countLabel: translator.t("!results.filters.departure.time.midday.count", {
      count: doc_count
    })
  }),
  [departure_time_range.late]: (translator, doc_count) => ({
    label: translator.t("!results.filters.departure.time.late.details"),
    countLabel: translator.t("!results.filters.departure.time.late.count", {
      count: doc_count
    })
  })
} satisfies {
  [x: string]: DepartureTimeDataGenerator;
};
